import { useState } from "react";
import { useNavigate } from "react-router-dom";
import InputField from "components/fields/InputField";
import { api, setToken, setRefreshToken, setUser } from "api";

export default function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError("");
    if (!email || !password) { setError("Email ve sifre zorunludur"); return; }
    setLoading(true);
    try {
      const res = await api.login(email, password);
      if (!res.user.is_admin) { setError("Bu panel sadece admin kullanicilara aciktir"); return; }
      setToken(res.access_token);
      setRefreshToken(res.refresh_token);
      setUser(res.user);
      navigate("/admin/default");
    } catch (e: any) {
      setError(e.message || "Giris basarisiz");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Mali Ajanda
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Admin paneline giris yapin
        </p>

        {error && (
          <div className="mb-4 rounded-xl bg-red-50 p-3 text-sm text-red-600 dark:bg-red-900/20 dark:text-red-400">
            {error}
          </div>
        )}

        <div onKeyDown={(e) => e.key === "Enter" && handleLogin()}>
          <InputField variant="auth" extra="mb-3" label="Email*" placeholder="Email adresiniz" id="email" type="email" value={email} onChange={(e: any) => setEmail(e.target.value)} />
          <InputField variant="auth" extra="mb-3" label="Sifre*" placeholder="Min. 8 karakter" id="password" type="password" value={password} onChange={(e: any) => setPassword(e.target.value)} />
        </div>

        <button onClick={handleLogin} disabled={loading}
          className="linear mt-4 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:opacity-50">
          {loading ? "Giris yapiliyor..." : "Giris Yap"}
        </button>
      </div>
    </div>
  );
}
